import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';

const API_AUTH_URL = `${environment.apiUrl}/auth`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) {}

  // public methods
  login(username: string, password: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_AUTH_URL}/login`, {
      username,
      password,
    });
  }

  // public methods
  logout(fcmToken: string, token: string): Observable<any> {
    return this.http.post<AuthModel>(
      `${API_AUTH_URL}/logout`,
      { fcmToken },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      }
    );
  }

  // public methods
  update(
    companyName: string,
    companyPhone: string,
    companyEmail: string,
    companyIcon: string,
    token: string
  ): Observable<any> {
    return this.http.post<AuthModel>(
      `${API_AUTH_URL}/update`,
      {
        companyName,
        companyPhone,
        companyEmail,
        companyIcon,
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      }
    );
  }

  // public methods
  changePassword(
    currentPassword: string,
    newPassword: string,
    token: string
  ): Observable<any> {
    return this.http.post<AuthModel>(
      `${API_AUTH_URL}/change-password`,
      { currentPassword, newPassword },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      }
    );
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_AUTH_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_AUTH_URL}/forgot-password`, {
      email,
    });
  }

  getUserByToken(token): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<UserModel>(`${API_AUTH_URL}/profile`, {
      headers: httpHeaders,
    });
  }

  notifications(token): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.post<any[]>(
      `${API_AUTH_URL}/notification-list`,
      { pageSize: 100 },
      {
        headers: httpHeaders,
      }
    );
  }

  getNotification(userNotificationId, token): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.post<any[]>(
      `${API_AUTH_URL}/get-notification`,
      { userNotificationId },
      {
        headers: httpHeaders,
      }
    );
  }

  addToken(token) {
    const url = `${API_AUTH_URL}/addToken`;
    return this.http.post(
      url,
      {
        token,
      },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${
            JSON.parse(
              localStorage.getItem(
                `${environment.appVersion}-${environment.USERDATA_KEY}`
              )
            ).token
          }`,
        }),
      }
    );
  }
}
